import { useSelector } from "react-redux";
import Select from "react-select";
import { CSVLink } from "react-csv";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import {
  getExportPackageCreationAction,
  getPackageCreationAction,
} from "../../../../redux/actions/TestPackageCreationAction";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  CSVData,
  PackageCreationHeader,
  initialFilterState,
  tableHeaderPackageCreation,
} from "./helper";
import PaginatedItems from "../../../../common/Pagination";
import { TableHeaderAdmin } from "../../HelloAdmin/helper";
import { clearCurrentPage } from "../../ProviderProfileDetails/helper";
import { getNetworkMenuId } from "../../../../Utils/types";

const TableFilterPage = ({
  setShowCreationPage,
  setIsRowData,
  searchFilter,
  setSearchFilter,
}) => {
  const dispatch = useDispatch();
  const [multiSelect, setMultiSelect] = useState([]);
  const[selectAllFlag,setSelectAllFlag] = useState(false)
  const [selectAll, setSelectAll] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [excelSheetData, setExcelSheetData] = useState([]);

  const TestPackageCreationReducer = useSelector(
    (state) => state?.TestPackageCreationReducer
  );
  const globalReducer = useSelector((state) => state?.globalReducer);

  useEffect(() => {
    dispatch(
      getPackageCreationAction({
        ...searchFilter,
        page: globalReducer?.getCurrentPage,
      })
    );
  }, [globalReducer?.getCurrentPage]);

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    setSearchFilter({ ...searchFilter, page: 1 });
    dispatch(
      getPackageCreationAction({
        ...searchFilter,
        page: 1,
      })
    );
  };

  const handleClearFilter = () => {
    setSearchFilter(initialFilterState);
    clearCurrentPage(dispatch);
    setMultiSelect([]);
    setSelectAll(false);
    setSelectAllFlag(false)
    dispatch(getPackageCreationAction(initialFilterState));
  };

  const ExportToExcelHandler = async () => {
    setIsLoadingExcel(true);
    const resp = dispatch(
      getExportPackageCreationAction({
        ...searchFilter,
        facilityIds: selectAll ? "" : multiSelect?.toString(),
        page: undefined,
        rows: undefined,
      })
    );
    resp?.then((res) => {
      if (res?.data?.status === true) {
        setExcelSheetData(res?.data?.results);
        setIsLoadingExcel(false);
      } else {
        setIsLoadingExcel(false);
      }
      setTimeout(() => {
        document.getElementById("exportexcel").click();
      }, 500);
    });
  };

  const SortHandler = (sortColumnName, sortDirection) => {
    clearCurrentPage(dispatch);
    setSearchFilter({
      ...searchFilter,
      page: 1,
      SortColumn: sortColumnName,
      sortDirection: sortDirection,
    });
    dispatch(
      getPackageCreationAction({
        ...searchFilter,
        page: 1,
        SortColumn: sortColumnName,
        sortDirection: sortDirection,
      })
    );
  };

  const facilityIds = TestPackageCreationReducer?.getPackageCreation?.map(
    (ele) => {
      return ele?.facilityId;
    }
  );

  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <h4> Package Creation </h4>
          <div className="row-filter">
            <input
              type="text"
              className="white-form-select"
              placeholder="Package Name"
              value={searchFilter?.facilityName}
              onChange={(e) => changeHandler("facilityName", e.target.value)}
            />
            <select
              className="white-form-select"
              value={searchFilter?.packageTypeId}
              onChange={(e) => changeHandler("packageTypeId", +e.target.value)}
            >
              <option value={0}> Package Type </option>
              <option value={1}>
                Standard (Applicable on All CBU Clients)
              </option>
              <option value={2}> Client Specific </option>
            </select>
            {searchFilter?.packageTypeId === 2 && (
              <Select
                className="basic-multi-select w-19"
                style={{ width: "100%" }}
                classNamePrefix="select"
                placeholder="Select Client"
                name="colors"
                isClearable={true}
                options={TestPackageCreationReducer?.getClientListNetwork?.map(
                  (ele) => {
                    return {
                      value: ele?.clientId,
                      label: ele?.clientName,
                    };
                  }
                )}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    clientId: e === null ? 0 : e?.value,
                    clientName: e === null ? e : e?.label,
                  });
                }}
                value={
                  searchFilter?.clientId
                    ? {
                      value: searchFilter?.clientId,
                      label: searchFilter?.clientName,
                    }
                    : null
                }
              />
            )}
            <select
              className="white-form-select"
              value={searchFilter?.isActive}
              onChange={(e) => {
                changeHandler("isActive", e.target.value);
              }}
            >
              <option value="">Select Status</option>
              <option value="Y"> Active </option>
              <option value="N"> Inactive </option>
            </select>
            <div className="search" type="button" onClick={handleSearch}>
              <a className="sidebar-links">
                <SearchIcon />
                <span className="sidebar-link-text">Search</span>
              </a>
            </div>
            <div className="search" type="button" onClick={handleClearFilter}>
              <a className="sidebar-links">
                <span className="sidebar-link-text">Clear All</span>
              </a>
            </div>
          </div>
          <div className="row-results">
            <div className="d-flex gap-10">
              <select
                className="row-selectdropdown"
                value={searchFilter?.rows}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    page: 1,
                    rows: e.target.value,
                  });
                  dispatch(
                    getPackageCreationAction({
                      ...searchFilter,
                      rows: e.target.value,
                      page: 1,
                    })
                  );
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
              <p className="results">
                Total <span>{globalReducer?.getTotalCount}</span> results
              </p>
            </div>
            <div>
              {multiSelect?.length ? (
                <div className="select_all_div">
                  {!selectAll && (
                    <>
                      <p>{multiSelect?.length} packages are selected</p>
                      {selectAllFlag === true && <span
                        className="select_all_primary_cases"
                        onClick={() => setSelectAll(true)}
                      >
                        Select all {globalReducer?.getTotalCount} packages
                      </span>}
                    </>
                  )}
                  {selectAll && (
                    <p>{globalReducer?.getTotalCount} packages are selected</p>
                  )}
                </div>
              ) : null}
            </div>
            <div className="d-flex gap-10">
              {getNetworkMenuId()?.canEdit &&
                <button
                  className={`btn search__btn`}
                  type="button"
                  onClick={() => {
                    setShowCreationPage(true);
                    setIsRowData(null);
                  }}
                >
                  <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp;
                  {window.innerWidth <= 700 ? "Create" : "Create Package"}
                </button>}
              <button
                className={`btn ${!isLoadingExcel ? "search__btn" : "disabled_btn"
                  }`}
                type="button"
                onClick={!isLoadingExcel && ExportToExcelHandler}
                disabled={!multiSelect?.length}
              >
                <i className="fa-solid fa-arrow-down"></i>&nbsp;
                {isLoadingExcel ? "Exporting..." : "Export To Excel"}
              </button>
              <CSVLink
                style={{ display: "none" }}
                id="exportexcel"
                data={CSVData(excelSheetData)}
                headers={PackageCreationHeader}
                filename={"packagecreation.csv"}
              ></CSVLink>
            </div>
          </div>
          <div className="table-responsive __custom__properties">
            <table className="table">
              <thead>
                <tr className="avanishtbl">
                  <th>
                    <input
                      type="checkbox"
                      onClick={(e) =>
                        e?.target?.checked
                          ? (setSelectAll(false),setSelectAllFlag(true),
                            setMultiSelect([
                              ...new Set(
                                [
                                  ...multiSelect,
                                  ...TestPackageCreationReducer?.getPackageCreation?.map(
                                    (ele) => {
                                      return ele?.facilityId;
                                    }
                                  ),
                                ].map((item) => item)
                              ),
                            ]))
                          : (setSelectAll(false),setSelectAllFlag(false),
                            setMultiSelect(
                              multiSelect?.length === 10
                                ? []
                                : multiSelect?.filter(
                                  (item) => !facilityIds.includes(item)
                                )
                            ))
                      }
                      checked={facilityIds?.every((r) =>
                        multiSelect?.includes(r)
                      )}
                      className="form-check-input"
                      readOnly
                    />
                  </th>
                  {tableHeaderPackageCreation?.map((ele, index) => {
                    return (
                      <TableHeaderAdmin
                        key={index}
                        header={ele?.name}
                        searchFilter={searchFilter}
                        SortHandler={SortHandler}
                      />
                    );
                  })}
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {TestPackageCreationReducer?.getPackageCreation?.map(
                  (ele, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            onClick={(e) =>
                              e?.target?.checked
                                ? (setSelectAll(false),
                                  setMultiSelect([
                                    ...multiSelect,
                                    ele?.facilityId,
                                  ]))
                                : (setSelectAll(false),
                                  setMultiSelect(
                                    multiSelect.filter(
                                      (value) => value !== ele?.facilityId
                                    )
                                  ))
                            }
                            checked={multiSelect?.some(
                              (element) => element === ele?.facilityId
                            )}
                            className="form-check-input"
                            readOnly
                          />
                        </td>
                        <td
                          className={`${ele?.isActive === "Y"
                            ? "tbl-textgreen"
                            : "tbl-textred"
                            }`}
                        >
                          {ele?.facilityName}
                        </td>
                        <td>{ele?.packageType}</td>
                        <td style={{ width: "250px" }}>{ele?.clientName}</td>
                        <td>{ele?.isFasting}</td>
                        <td>{ele?.isHVAllowed}</td>
                        <td>{ele?.gender}</td>
                        <td>{ele?.isActive === "Y" ? "Yes" : "No"}</td>
                        <td
                          style={{
                            cursor: !getNetworkMenuId()?.canEdit
                              ? "default"
                              : "pointer",
                          }}
                          onClick={() => {
                            if (getNetworkMenuId()?.canEdit) {
                              setShowCreationPage(true);
                              setIsRowData(ele);
                            }
                          }}
                        >
                          <img src="./../images/edit-icon.png" />
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-row">
            {globalReducer?.getTotalCount !== 0 && (
              <PaginatedItems
                totalCount={globalReducer?.getTotalCount}
                perPageData={searchFilter?.rows}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableFilterPage;
